import type { IMissionRuntime, MissionKernel } from "@ports/missions/IMissionRuntime";
import { missionPackage } from "./missionPackage";

/**
 * `IMissionRuntime` over the shared deferred import. Constructing it loads nothing; the first `load()`
 * starts the import, and every later call (concurrent ones included) gets that same promise, so each
 * caller sees one kernel. A failed import (a chunk that did not download) drops this adapter's own
 * memo, so a retry is possible: the next `load()` calls the import again instead of returning the
 * rejected promise. Whether that re-fetches the chunk is up to the module loader; a browser may keep
 * the failed import cached and reject again.
 */
export class MissionRuntime implements IMissionRuntime {
	private kernel: Promise<MissionKernel> | undefined;

	load(): Promise<MissionKernel> {
		this.kernel ??= missionPackage().catch((err: unknown) => {
			this.kernel = undefined;
			throw err;
		});
		return this.kernel;
	}
}
